import { atom } from "recoil";

export const getEmptyProviderEditValues = () => ({
	name: null,
	path: null,
	order: null,
	listed: null,
	active: null,
	integrationType: null,
	restrictedCountries: null,
	currency: null,
	fee: null,
	logoSvg: null,
	logoPreview: null,
	logoError: "",
});

export const providerEditModalStore = atom({
	key: "providerEditModalStore",
	default: {
		show: false,
		mode: "bulk",
		loaded: true,
		selectedIds: [],
		values: getEmptyProviderEditValues(),
		initialValues: null,
		storedErrors: {},
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
